import { Component, ChangeDetectionStrategy, OnInit, Input } from '@angular/core';

import { AuthTypeComponent } from '../auth-type.shared.component';
import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';

@Component({
    selector: 'shared-auth-for-unique-code-error',
    templateUrl: './auth-for-unique-code-error.shared.component.html',
    styleUrls: ['./auth-for-unique-code-error.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthForUniqueCodeErrorComponent extends AuthTypeComponent implements OnInit {
    @Input() public label: string = 'SIGN IN / UP';
    public errorType$!: Observable<number>;
    public errorText$!: Observable<string>;

    constructor(
        public controllers: Controllers,
    ) {
        super(controllers);
    }

    ngOnInit(): void {
        this.errorType$ = this.controllers.members.uniqueCodeErrorType$();
        this.errorText$ = this.controllers.members.uniqueCodeErrorText$();
    }

    public handleSignInClick($event: Event): void {
        this.controllers.members.goToLoginAuthStep(true);
    }
}
